import { APICore } from 'helpers/api/apiCore';

export default function useEnterprise() {
    const api = new APICore();

    return [api.getEnterprise()];
}